import { render } from "./NotAccentedButton.vue?vue&type=template&id=2e8e6699"
import script from "./NotAccentedButton.vue?vue&type=script&lang=js"
export * from "./NotAccentedButton.vue?vue&type=script&lang=js"

import "./NotAccentedButton.vue?vue&type=style&index=0&id=2e8e6699&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__